import styles from './Lineage.module.css';
import {useState} from 'react';
import { useRecoilState } from 'recoil';
import { lineageDiffState } from '../../../recoil/atoms';
import getFormatDate from '../../../utils/getFormatDate';
import getUsername from "../../../utils/getUsername";
import ToolTip from "../../../compoenets/ToolTip";
import { formToJSON } from 'axios';

const DetailItem = ({className, label, value}) => {
    return (
        <ToolTip message={value}>
            <div className={`${className} ${styles['detail-item']}`}>
                <span>{label}</span>
                <span>{value}</span>
            </div>
        </ToolTip>
    )
}

const LineageItem=({item,onClick,isExpand,onLineageChange,onDiff})=>{
  const [, setLineageDiff]=useRecoilState(lineageDiffState);
  const handleClick = () => {
      onClick();
      setLineageDiff(onDiff());
      onLineageChange(item.detail.snapshot);
  }

  return(
    <div className={`${styles['item']} ${isExpand && styles['item-expand']}`}>
      <div className={`${styles['graph']} ${isExpand && styles['graph-expand']}`}></div>
      <div 
      className={styles['node-wrap']}
      onClick={handleClick}
      >
        <div className={`${styles['node']} ${isExpand && styles['node-expand']}`}>
          <div className={`${styles['date']} ${isExpand && styles['date-expand']}`}>{getFormatDate(item.event.createdTime)}</div>
          <div className={styles['detail']}>
            <DetailItem label="Event" value={item.eventType}/>
            <DetailItem label="User" value={getUsername(item.event.userMail)}/>
            <DetailItem label="From" value={item.event.from}/>
            <DetailItem label="To" value={item.event.to}/>
            <DetailItem className={styles['detail-item-large']} label="Message" value={item.event.message}/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function Lineage({data, onLineageChange}) {
  const [activeItem, setActiveItem] = useState(null);

  const handleItemDiff=(prev,next)=>{
    if(prev===undefined || next===undefined)return null;

    const changedKeys=[];
    const allKeys=new Set([...Object.keys(prev),...Object.keys(next)]);

    for(const key of allKeys){
      const prevValue=JSON.stringify(prev[key]);
      const nextValue=JSON.stringify(next[key]);
      if(prevValue!==nextValue){
        changedKeys.push(key)
      }
    }

    return changedKeys;
  }

  return (
  <div className={styles['wrap']}>
    {data.items&&data.items.map((item,index)=>
    <LineageItem
    item={item}
    onClick={()=>setActiveItem(item.revision)}
    isExpand={activeItem===item.revision}
    onLineageChange={onLineageChange}
    onDiff={()=>handleItemDiff(item.detail.snapshot,data.items[index+1]?.detail.snapshot)}
    />
    )}
  </div>
  )
}